import { render, staticRenderFns } from "./AccountingAccountAjout.vue?vue&type=template&id=31eeb6b8&"
import script from "./AccountingAccountAjout.vue?vue&type=script&lang=js&"
export * from "./AccountingAccountAjout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports